export default String.raw`
.ai-recommendations-item {
    flex: 1 0 190px;
    display: flex;
    height: 100%;
    max-height: 100%;
    max-width: 190px;

    &__image-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 190px;
            height: 190px;
            aspect-ratio: 1;

        img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            border-radius: 4px;
        }
    }
    &__flags {
        position: absolute;
        top: 8px;
        left: -4px;
    }

    &__flag {
        width: fit-content;
        font-size: 10px;
        font-weight: 500;
        line-height: 15px;
        padding: 2px 8px;
        margin-bottom: 2px;
        border-radius: 2px;

        &.quantity-flag {
            background: $primaryColor;
            color: $lightestColorFont;
        }
    }
    &__section {
        margin: 16px 0;

        &:last-of-type {
            margin: 0;
        }

        &.btn-section {
            position: absolute;
            top: 0;
            right: 0;
        }
    }
    &__name {
        height: 40px;
        @include body-1-regular;
        color: $primaryColorFont;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    &__price-wrapper {
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
    }
    &__price {
        @include body-1-regular;
        margin-right: 8px;

        &.bold-price {
            @include body-1-medium;
        }

        &.old-price {
            font-size: 12px;
            line-height: 18px;
            text-decoration: line-through;
            display: flex;
            align-items: center;

            svg {
                width: 12px;
                height: 12px;
                text-decoration: none;
                margin-left: 4px;
            }
        }
    }

    &__deposit-price {
        color: #767676;
        @include body-3-medium;
    }

    &__omnibus {
        margin-top: 8px;
        color: #767676;
        @include body-3-medium;
    }

    &__primary-btn {
        padding: 8px;
    }
}
`